export const checksums = {
  "index": "v3.5.0--BVq_khNHs92bhdUYtxWd4ZsSn7HsfSlZn_9Qa1Cti9M",
  "docsv5": "v3.5.0--X2DPGtxwjRY262SR9RR_Ozi0XdKVhiRoDU3__rK7-lo",
  "docsv4": "v3.5.0--GaUgUARVzAbsJaW_Fw0oE_IbJ8ne3HizkVXHox6ZX1o",
  "docsv3": "v3.5.0--j4w8TjC5q4rF3iDBf9zj8d7gEtCCYYXdNXGqNKW1ul0",
  "blog": "v3.5.0--vB79bOboUHZ0JW-nQ5OICbaXInlqItVN11zg7MkSwwc",
  "landing": "v3.5.0--cOST00c-vD8bE7xp1mG_ryuiyyKXiWl8y2cnx6MJn_U",
  "deploy": "v3.5.0--mU6PeTVuO9OO3sTYpwsrqOXJ99U9J-J9icSTGlrT8ZE",
  "manualSponsors": "v3.5.0--f1q8W-mSrg5kE8I31t8PtF4nNX5IDk8a3DU-qZWbLYE",
  "support": "v3.5.0--euT2wOQwCvsmZlUf2kN5TQrPUAgcNPAPR4klmLsG13w",
  "agencies": "v3.5.0--WNrXerSSK9nVMbHnLAOeZAoMTjixptJImNfHPrmxCwE",
  "templates": "v3.5.0--Y55mRHMum1UVjwfLCYQxVX396a_Wck_njVuxtW4toww",
  "showcase": "v3.5.0--Dd6Y_-D-mzP7X_5c8oabIK7BTAJ2QAnDtgAy4R_XQ6U",
  "videoCourses": "v3.5.0--eOUG75kwrE6AuQK04Z3mY1jSbdJ3--RCzxjwHjs2Bto",
  "designKit": "v3.5.0--10RRgIBwAnh7TVVDHbhXlOX7OXedL6aj28Kvj7d6CDU",
  "team": "v3.5.0--D23Ik8xh7XogVXh19Va1Qf6gtN8QLU64EOfBLsZSKQY",
  "evals": "v3.5.0--DVMGX9YHrha1JgqWGN5bFUgpCG-J3jz0Zurby6sh2po"
}
export const checksumsStructure = {
  "index": "rbMG1eOiUTNGy_xyk9VPcrt70I6t8ckzwxQB33q9CGk",
  "docsv5": "LY_d6X32icoXV2E1hj6loNuyTNG9nth3U1oyv2Us2do",
  "docsv4": "5sf5xuLFLUh4vqoW8rc7pR2H6m8NSJQYZAdGmkWaT_I",
  "docsv3": "rkw3JY8nBFL9jBjiyqBfGx0oDNwnW5ntjbrgkTlGIPw",
  "blog": "WgUd18D3Q0Jx3VKDhW-m07WC1LQ_aRTQjEnRMbXDF1E",
  "landing": "rJ389Ea_TupBiPEM_ltxLvb4bcdeovLQ-AzrE7Q_QzQ",
  "deploy": "4mtayZCub7jl0L7d7LERlELG6O29SHe-ma7K3X_Lx8g",
  "manualSponsors": "hNm7u_hUfJaLUtob_rlt7cFwObGEnvQVvJJybVYfEgg",
  "support": "euT2wOQwCvsmZlUf2kN5TQrPUAgcNPAPR4klmLsG13w",
  "agencies": "AZBiQC6U2yTzFqAEigeawd0imxPnvfPcLSxKGaU3FqU",
  "templates": "mOhfHlGbIfAFAONJdvsgJQxXSpoDswEcBBuK0IKxtxo",
  "showcase": "GS-EyXqKNXTznwMumU0vtQ1D0_OStp5z2_kiAS1Ittw",
  "videoCourses": "wJKAQGHX09gpxMMnLo9zJN_o1C6fSFzijucqsfoHMSM",
  "designKit": "QhkqnRnEvsBJC94PTxTWnZQByc-2lhyP2l0FdPUhwtw",
  "team": "gYK-0e38oFyVG-erkUhQTjcH3sSIM7poSVHk_G_hXz4",
  "evals": "P-ciG-DRWXw4N1hwUGtiFuk9cnobbF5ivUJk5pZ7nrw"
}

export const tables = {
  "index": "_content_index",
  "docsv5": "_content_docsv5",
  "docsv4": "_content_docsv4",
  "docsv3": "_content_docsv3",
  "blog": "_content_blog",
  "landing": "_content_landing",
  "deploy": "_content_deploy",
  "manualSponsors": "_content_manualSponsors",
  "support": "_content_support",
  "agencies": "_content_agencies",
  "templates": "_content_templates",
  "showcase": "_content_showcase",
  "videoCourses": "_content_videoCourses",
  "designKit": "_content_designKit",
  "team": "_content_team",
  "evals": "_content_evals",
  "info": "_content_info"
}

export default {
  "index": {
    "type": "data",
    "fields": {
      "id": "string",
      "contributors": "json",
      "deploy": "json",
      "extension": "string",
      "features": "json",
      "foundation": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "modules": "json",
      "sponsors": "json",
      "stats": "json",
      "stem": "string",
      "support": "json",
      "testimonial": "json"
    }
  },
  "docsv5": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "docsv4": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "docsv3": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "body": "json",
      "category": "string",
      "date": "date",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "image": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "deploy": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "componentImg": "string",
      "description": "string",
      "extension": "string",
      "logoIcon": "string",
      "logoSrc": "string",
      "meta": "json",
      "navigation": "json",
      "nitroPreset": "string",
      "path": "string",
      "seo": "json",
      "sponsor": "boolean",
      "stem": "string",
      "website": "string"
    }
  },
  "manualSponsors": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "sponsors": "json",
      "stem": "string"
    }
  },
  "support": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "expertise": "json",
      "extension": "string",
      "form": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "project": "json",
      "service": "json",
      "stem": "string",
      "testimonials": "json"
    }
  },
  "agencies": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "color": "json",
      "description": "string",
      "emailAddress": "string",
      "extension": "string",
      "github": "string",
      "instagram": "string",
      "link": "string",
      "linkedin": "string",
      "location": "string",
      "logo": "json",
      "logoFull": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "phoneNumber": "string",
      "regions": "json",
      "resources": "json",
      "seo": "json",
      "services": "json",
      "stem": "string",
      "x": "string"
    }
  },
  "templates": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "demo": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "meta": "json",
      "name": "string",
      "purchase": "string",
      "repo": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "showcase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "extension": "string",
      "head": "json",
      "meta": "json",
      "stem": "string",
      "websites": "json"
    }
  },
  "videoCourses": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "sponsor": "boolean",
      "stem": "string",
      "url": "string"
    }
  },
  "designKit": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "team": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "users": "json"
    }
  },
  "evals": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "extension": "string",
      "githubUrl": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}